export default "__VITE_ASSET__B4ujG_oB__"